import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirestoreClickWrapAccepted } from '../firestore/ClickWrapAccepted/schema'
import { empty } from '../firestore/ClickWrapAccepted/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class ClickWrapAccepted extends ObservableModelWithDecorators<FirestoreClickWrapAccepted> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreClickWrapAccepted>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
